<template>
  <!-- CUB-954: шапка рабочего интерфейса в стиле продуктового фронта — организация, переходы в
       «Рабочее место» / «Экраны» / «Мои задачи» в той же вкладке. Названия — те же, что в продукте.
       Домен без организации (корпоративный инстанс) продукта не имеет — тогда блок не рисуется. -->
  <div
    v-if="enabled"
    class="cbs-product-bar"
    :class="{ compact }"
  >
    <a
      v-if="!compact"
      href="#"
      class="cbs-pb-org"
      :title="'Сменить организацию'"
      @click.prevent="go('/orgs')"
    >
      <span class="cbs-pb-mark">{{ orgInitial }}</span>
      <span class="cbs-pb-orgname">{{ ctx.orgname || 'Организация' }}</span>
    </a>
    <a
      href="#"
      class="cbs-pb-link"
      :class="{ primary: compact }"
      @click.prevent="go(workPath())"
    >{{ compact ? '← Рабочее место' : 'Рабочее место' }}</a>
    <template v-if="!compact">
      <a
        href="#"
        class="cbs-pb-link"
        @click.prevent="go(`/orgs/${ctx.orgid}/apps`)"
      >Экраны</a>
      <a
        href="#"
        class="cbs-pb-link"
        @click.prevent="go(`/orgs/${ctx.orgid}/inbox`)"
      >Мои задачи</a>
    </template>
  </div>
</template>

<script>
import useJwt from '@/cubus/jwt/useJwt'
import useCubus from '@/cubus/services/useCubus'

export default {
  name: 'CbsProductBar',
  props: {
    /** на странице записи (раскладка без шапки) — одна кнопка «← Рабочее место» */
    compact: { type: Boolean, default: false },
  },
  data() {
    return { ctx: null, busy: false }
  },
  computed: {
    /**
     * Блок — только когда продукт у инстанса действительно есть. На бою 27.09 адрес продукта не
     * настроен и бэк отдаёт умолчание `http://localhost:5180` — шапка вела всех в никуда. Адрес на
     * localhost принимаем только при локальной разработке.
     */
    enabled() {
      const c = this.ctx
      if (!c || !c.productUrl || !c.orgid) return false
      const local = /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/i.test(c.productUrl)
      const here = window.location.hostname
      return !local || here === 'localhost' || here === '127.0.0.1'
    },
    orgInitial() {
      const n = (this.ctx && this.ctx.orgname) || ''
      return n ? n.trim().charAt(0).toUpperCase() : 'C'
    },
  },
  mounted() {
    useJwt.axiosIns.get('/api/sso/context')
      .then(r => { this.ctx = r.data || null })
      .catch(() => { this.ctx = null })
  },
  methods: {
    okey(o) {
      return /^\d+$/.test(String(o)) ? `id:${o}` : String(o)
    },
    /** Путь в продукте, соответствующий открытому здесь объекту или записи. */
    workPath() {
      const base = `/orgs/${this.ctx.orgid}/domains/${this.ctx.domainsid}/work`
      const r = this.$route
      if (r.name === 'cubus-object' && r.params.objectid) return `${base}?o=${encodeURIComponent(this.okey(r.params.objectid))}`
      if (r.name === 'record-page' && r.params.object) {
        const rec = String(r.params.record || '')
        return `${base}?o=${encodeURIComponent(this.okey(r.params.object))}${/^\d+$/.test(rec) ? `&r=${rec}` : ''}`
      }
      return base
    },
    /** Переход в продукт той же сессией: одноразовый код → /auth/sso продукта → next. */
    go(next) {
      if (this.busy) return
      this.busy = true
      useJwt.axiosIns.post('/api/sso/code', {})
        .then(r => {
          const code = r.data && r.data.code
          const base = (r.data && r.data.productUrl) || this.ctx.productUrl
          if (!code || !base) throw new Error('Не удалось перейти в рабочее место')
          window.location.assign(`${base}/auth/sso?code=${encodeURIComponent(code)}&next=${encodeURIComponent(next)}`)
        })
        .catch(e => {
          this.busy = false
          useCubus.toastError(this, e)
        })
    },
  },
}
</script>

<style scoped>
.cbs-product-bar {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 12px;
  font-family: "Inter Variable", "Inter", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif;
  letter-spacing: -0.011em;
  font-size: 0.84375rem;
}
.cbs-product-bar.compact {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1050;
  margin: 0;
}
.cbs-pb-org {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin-right: 6px;
  border-radius: 6px;
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
}
.cbs-pb-org:hover { background: #f1f5f9; }
.cbs-pb-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.cbs-pb-orgname {
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cbs-pb-link {
  padding: 6px 10px;
  border-radius: 6px;
  color: #475569;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}
.cbs-pb-link:hover { background: #f1f5f9; color: #0f172a; }
.cbs-pb-link.primary {
  background: #4353e4;
  color: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.15);
}
.cbs-pb-link.primary:hover { background: #3641c9; color: #fff; }
</style>
